import { reactive } from 'vue';

export const criarPlaMelItem = () => {
  return reactive({
    id: 0,
    idplamel: 0,
    dtrecebimento: '',
    nmrota: '',
    nroapicultor: 0,
    dtcoleta: '',
    qtd: 0,
    lote: '',
    flpredominante: '',
    umidade: 0,
    idlogin: 0,
    idusuario: 0
  });
};